const mutations = {
  SET_CURRENT_USER (state, user) {
    state.current_user.set(user)
  },
  SET_PERMISSIONS (state, permissions) {
    state.permissions = permissions
  },
  SET_NOTIFICATIONS (state, notifications) {
    state.notifications = notifications
  },
  SET_HANDLED_CASES (state, bool) {
    state.handledCasesAreVisible = bool
  }
}
export default mutations
